import { render, staticRenderFns } from "./knowledgeAdd.vue?vue&type=template&id=36df1b54&scoped=true"
import script from "./knowledgeAdd.vue?vue&type=script&lang=js"
export * from "./knowledgeAdd.vue?vue&type=script&lang=js"
import style0 from "./knowledgeAdd.vue?vue&type=style&index=0&id=36df1b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df1b54",
  null
  
)

export default component.exports